import React from "react";
import styled from "styled-components";
import { Body3 } from "../../../../assets/styles/Typography";
import { palette } from "../../../../assets/styles/Palette";
import { CheckBoxButton } from "../../../../assets/styles/InputStyle";


// 이미지 import 추가
import DarkMode from "../../../../assets/images/dark_mode.png";
import LightMode from "../../../../assets/images/light_mode.png";


const OrganismDesignConceptSelector = ({
  concepts = [],
  selectedConcepts = [],
  onSelect,
  disabled = false,
  onPreview,
}) => {
  const isSelected = (conceptId) => {
    return selectedConcepts.includes(conceptId);
  };

  const isDisabled = (concept) => {
    return (
      disabled ||
      // concept.name === "기본 심플형" ||
      concept.name === "어두운 기본형"
    );
  };

  const handleToggle = (conceptId, fromCheckbox = false) => {
    // if (!isDisabled(concepts.find(c => c.id === conceptId))) {
      onSelect(conceptId);
    // }
  };

   // 컨셉트별 이미지를 반환하는 함수
  const getPreviewImage = (conceptName) => {
    switch(conceptName) {
      case "라이트 모드":
        return LightMode;
      case "다크 모드":
        return DarkMode;
  
      default:
        return LightMode;
    }
  };


  return (
    <ConceptSelectorWrapper>
      <ConceptGrid>
        {concepts.map((concept) => (
          <ConceptCard
            key={concept.id}
            selected={isSelected(concept.id)}
            onClick={(e) => {
              if (e.target.type !== 'checkbox' && e.target.getAttribute('data-preview') !== 'true') {
                handleToggle(concept.id);
              }
            }}
          >
            <ConceptHeader style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "8px",
                  width: "100%",
                }}
              >
                <CheckBoxButton
                  id={concept.id}
                  name={concept.id}
                  checked={isSelected(concept.id)}
                  onChange={() => handleToggle(concept.id, true)}
                  style={{ cursor: "pointer", marginTop: "2px" }}
                />
                <div style={{ flex: 1, textAlign: "left" }}>
                  <Body3 color="gray800" style={{ fontWeight: "600" }}>
                    {concept.name}
                  </Body3>
                </div>
              </div>
              <PreviewButton
                type="button"
                data-preview="true"
                onClick={() => onPreview && onPreview(concept)}
                style={{whiteSpace: "nowrap"}}
              >
                 <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.4982 5.97656C17.0176 5.97656 21.0841 8.45875 22.3546 11.834C22.479 12.1648 22.497 12.5362 22.3849 12.8906C21.61 15.3386 18.5559 18.5762 12.4982 18.5762C6.4168 18.576 3.42075 15.0231 2.63488 12.918C2.50683 12.5749 2.50547 12.2079 2.61144 11.875C3.16333 10.1415 4.5396 8.66789 6.28332 7.6377C8.03511 6.60278 10.2185 5.97664 12.4982 5.97656ZM12.4982 7.57617C10.5026 7.57625 8.60015 8.1265 7.09679 9.01465C5.58531 9.90763 4.53672 11.1045 4.13683 12.3604C4.13651 12.3614 4.13602 12.3626 4.13585 12.3633C4.70504 13.8806 7.12813 16.9764 12.4982 16.9766C17.9325 16.9766 20.3163 14.1228 20.8595 12.4092L20.8566 12.3975C19.8773 9.79587 16.5276 7.57617 12.4982 7.57617ZM12.4991 8.47656C14.5978 8.47656 16.2988 10.1778 16.2989 12.2764C16.2989 14.375 14.5978 16.0762 12.4991 16.0762C10.4005 16.0761 8.69933 14.375 8.69933 12.2764C8.69944 10.1778 10.4006 8.47667 12.4991 8.47656ZM12.4991 10.0762C11.2843 10.0763 10.299 11.0615 10.2989 12.2764C10.2989 13.4913 11.2842 14.4765 12.4991 14.4766C13.7142 14.4766 14.6993 13.4914 14.6993 12.2764C14.6992 11.0614 13.7141 10.0762 12.4991 10.0762Z" fill="#8A949E"/>
            </svg>
                미리보기
              </PreviewButton>
            </ConceptHeader>
         
              <PreviewImage
                src={getPreviewImage(concept.name)}
                alt={concept.name}
              />
       
            {/* <ConceptDescription>
              <Body3
                color="gray500"
                style={{ textAlign: "left", lineHeight: "1.4" }}
              >
                {concept.description}
              </Body3>
            </ConceptDescription> */}
          </ConceptCard>
        ))}
      </ConceptGrid>
    </ConceptSelectorWrapper>
  );
};

export default OrganismDesignConceptSelector;

const ConceptSelectorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const ConceptGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
`;

const ConceptCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  border: 1px solid
    ${(props) => {
      if (props.disabled) return "#E0E4EB";
      return props.selected ? palette.primary : "#E0E4EB";
    }};
  border-radius: 8px;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition: all 0.2s ease;
  background: ${(props) => {
    if (props.disabled) return "#F8F9FA";
    return props.selected ? "rgba(34, 111, 255, 0.05)" : "white";
  }};
  position: relative;
  opacity: ${(props) => (props.disabled ? "0.5" : "1")};


  &:hover {
    border-color: ${(props) => (props.disabled ? "#E0E4EB" : palette.primary)};
    background: ${(props) =>
      props.disabled ? "#F8F9FA" : "rgba(34, 111, 255, 0.02)"};
  }
`;

const ConceptHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  margin-bottom: 12px;
`;

const ConceptInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
`;

const ConceptDescription = styled.div`
  margin-top: 12px;
`;

// const ConceptPreview = styled.div`
//   width: 100%;
//   height: 180px;
//   background-color: #f8f9fa;
//   border-radius: 4px;
//   // border: 1px solid #e9ecef;
// `;

// 스타일드 컴포넌트 추가
const PreviewImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 4px;
`;

const PreviewButton = styled.button`
display: flex;
align-items: center;
gap: 4px;
background: none;
border: 1px solid #E0E4EB;
border-radius: 8px;
padding: 4px 12px;
font-size: 14px;
color: #888;
cursor: pointer;
transition: border 0.2s, color 0.2s;
margin-left: auto;
&:hover {
  border-color: #226FFF;
  color: #226FFF;
}
`;
